import { createFilter } from 'react-select';
import { t } from 'ttag';

import { GroupBase, SelectProps } from './types';
import { MultiValue } from './SelectInternalComponents/MultiValue';

export function getDefaultProps<
Option,
IsMulti extends boolean,
Group extends GroupBase<Option>,
>(props: SelectProps<Option, IsMulti, Group>): Partial<SelectProps<Option, IsMulti, Group>> {
  const {
    isDisabled,
    invalid,
    error,
  } = props;
  const hasError = Array.isArray(error) ? !!error.length : !!error;

  return {
    placeholder: t`Вибір`,
    noOptionsMessage: () => t`Поки нічого не знайдено`,
    components: {
      MultiValue,
    },
    theme: (theme) => ({
      ...theme,
      borderRadius: 0,
      colors: {
        ...theme.colors,
        primary: '#eee',
        primary75: '#26a69a',
        primary50: '#f7f7f7',
        primary25: '#f7f7f7',
      },
    }),
    styles: {
      container: (provided) => ({
        ...provided,
        width: '100%',
      }),
      control: (provided) => ({
        ...provided,
        boxShadow: '',
        minHeight: '40px',
        maxHeight: 'auto',
        border: (invalid || hasError) ? '1px solid red' : provided.border,
        color: isDisabled ? '#989898' : provided.color,
        borderColor: isDisabled ? '#d7d6d5' : '#D2D2D2',
        backgroundColor: 'white',
        borderRadius: '8px',
        cursor: 'pointer',
      }),
      option: (provided) => (
        {
          ...provided, cursor: 'pointer', zIndex: 100, color: '#000',
        }
      ),
      menu: (provided) => ({
        ...provided,
        cursor: 'pointer',
        color: '#414141',
        zIndex: 10,
        borderRadius: '8px',
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: props.isMulti && props.value ? '2px 2px' : '2px 8px',
      }),
    },
    filterOption: createFilter({
      ignoreAccents: false,
    }),
  };
}
